import React from 'react';
import { Phone } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Footer = () => {
    return (
        <footer className="bg-mgray text-mdark p-6 w-full">

            <div className='flex flex-col lg:flex-row justify-evenly items-center gap-4'>
                <div className="flex items-center">
                    <a href="https://www.meosis.fr/" target='_blank'>
                        <img
                            src={`${process.env.PUBLIC_URL}/LOGO-MEOSIS.png`}
                            alt="Logo Meosis"
                            className="h-8 w-auto"
                        />
                    </a>
                </div>
                <div className=' flex flex-col lg:flex-row items-center'>
                    <a className="mx-4" href="https://www.google.fr/maps?sca_esv=757e01b514b177ca&sxsrf=ADLYWIL9wpekkVf1D3ipSoG8qNxTrZrroQ:1729174462467&iflsig=AL9hbdgAAAAAZxEpzuZunD8hzOHqe7_iwqT1LgUNjBP_&gs_lp=Egdnd3Mtd2l6IgZtZW9zaXMqAggAMgoQIxiABBgnGIoFMgsQLhiABBjHARivATIFEAAYgAQyCxAuGIAEGMcBGK8BMgUQABiABDIFEAAYgAQyChAAGIAEGAoYywEyBRAAGIAEMgoQABiABBgKGMsBMg4QLhiABBjHARiOBRivAUizEVAAWIYEcAB4AJABAJgBWqAB-wOqAQE2uAEByAEA-AEBmAIGoAKnBMICBBAjGCfCAgsQABiABBixAxiDAcICCxAuGIAEGLEDGIMBwgIEEAAYA8ICCBAAGIAEGLEDwgIREC4YgAQYsQMY0QMYgwEYxwHCAggQLhiABBixA5gDAJIHATagB4xC&um=1&ie=UTF-8&fb=1&gl=fr&sa=X&geocode=KWUGPEU6ZpFHMQ7c8vivNEwO&daddr=1+Rue+de+Lugano,+68180+Horbourg-Wihr">
                        <FontAwesomeIcon icon="fa-solid fa-location-dot" className="pr-2 text-mlime" /> 1 rue de Lugano<span className='hidden lg:inline '>,</span> <br className='lg:hidden'></br> 68180 Horbourg-Wihr</a>
                    <a className="mx-4 my-2 ld:my-0" href="tel:0389308630"><FontAwesomeIcon icon="fa-solid fa-phone" className="pr-2 text-mlime" />03 89 30 86 30 </a>
                    <a className="mx-4" href="https://www.meosis.fr/contact.html"><FontAwesomeIcon icon="fa-solid fa-envelope" className="pr-2 text-mlime" /> Nous écrire</a>
                </div>
                <div className='flex items-center'> 
                    <a href="https://www.instagram.com/agence_meosis/" target='_blank' className="align-middle pr-4">
                        <FontAwesomeIcon icon="fa-brands fa-instagram" className="text-mlime text-xl hover:text-custom-green duration-300 hover:[color:#5a891b]" />
                    </a>
                    <a href="https://www.facebook.com/agence.meosis/" target='_blank' className="pr-4 ">
                        <FontAwesomeIcon icon="fa-brands fa-facebook-f" className="text-mlime hover:text-custom-green duration-300 text-xl hover:[color:#5a891b]" />
                    </a>
                    <a href="https://www.linkedin.com/company/meosis/?originalSubdomain=fr" target='_blank' className="pr-4">
                        <FontAwesomeIcon icon="fa-brands fa-linkedin" className="text-mlime  hover:text-custom-green  duration-300 text-xl hover:[color:#5a891b]" />
                    </a>
                    <a href="https://www.tiktok.com/@agence_meosis" target='_blank' className="pr-4">
                        <FontAwesomeIcon icon="fa-brands fa-tiktok" className="text-mlime hover:text-custom-green duration-300 text-xl hover:[color:#5a891b]" />
                    </a>
                   
                    <a href="https://www.google.com/maps/place/Meosis/@48.0727595,7.4048663,16z/data=!3m1!4b1!4m6!3m5!1s0x4791663a453c0665:0xe4c34aff8f2dc0e!8m2!3d48.0727595!4d7.4048663!16s%2Fg%2F1tj4xmsc?hl=fr-FR&entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D" target='_blank' className="pr-4 svg-logo-link text-mlime">
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                            className=" duration-300 mb-2 svg-logo"
                            style={{ height: '20px' }}
                            viewBox="0 0 100.000000 100.000000" preserveAspectRatio="xMidYMid meet"
                            > 
                            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" stroke="none">
                            <path d="M103 858 c-25 -12 -29 -23 -73 -196 -35 -135 -34 -156 8 -203 55 -61
                            158 -47 198 27 l18 33 12 -27 c17 -41 48 -63 95 -69 53 -8 100 16 125 63 l18
                            33 12 -27 c18 -44 50 -65 104 -70 50 -5 52 -4 95 41 37 39 45 43 50 28 11 -36
                            53 -64 103 -69 44 -4 52 -1 85 28 22 19 39 44 42 64 9 47 -60 316 -86 339 -19
                            16 -53 17 -403 16 -249 0 -389 -4 -403 -11z"/>
                            <path d="M211 414 c-26 -18 -47 -24 -87 -24 l-54 0 0 -175 c0 -162 2 -177 20
                            -195 19 -19 33 -20 408 -20 335 0 391 2 410 16 21 15 22 20 22 195 l0 179 -54
                            0 c-40 0 -62 6 -90 25 l-36 24 -36 -24 c-51 -35 -125 -35 -176 0 l-37 25 -37
                            -25 c-51 -35 -125 -35 -176 0 -20 14 -38 25 -40 24 -2 0 -18 -12 -37 -25z
                            m595 -115 c13 -10 13 -14 -1 -29 -13 -15 -21 -16 -45 -7 -65 25 -121 -72 -71
                            -122 28 -28 75 -27 104 1 l22 23 -37 3 c-33 3 -38 7 -38 28 0 23 3 24 60 24
                            l60 0 0 -30 c0 -92 -97 -148 -180 -105 -63 33 -80 129 -33 185 14 18 36 36 47
                            41 27 11 92 5 112 -12z"/>
                            </g>
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
